import { Dispatch, PropsWithChildren, SetStateAction, useState } from "react";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "@/components/ui/sheet";
import { Filter } from "lucide-react";
import { cn } from "@/lib";
import { ScrollArea } from "@/components/ui/scroll-area";
import { ButtonProps } from "@/components/ui/button";

type SheetFilterContainerProps = PropsWithChildren & {
  button?: React.ReactElement<ButtonProps> | React.ReactNode;
  defaultOpen?: boolean;
  className?: string;
  setDefaultOpen?: Dispatch<SetStateAction<boolean>>;
};
export function SheetFilterContainer({
  button,
  children,
  className,
  defaultOpen,
  setDefaultOpen,
}: SheetFilterContainerProps) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <Sheet defaultOpen={open} onOpenChange={setDefaultOpen || setOpen}>
      <SheetTrigger>{button}</SheetTrigger>
      <SheetContent className={cn("h-screen", className)}>
        <SheetHeader>
          <SheetTitle className="text-xl text-zinc-600 flex items-center gap-2">
            <Filter /> <span className="font-bold">Filtrar por:</span>
          </SheetTitle>
        </SheetHeader>
        <ScrollArea className="pt-10 h-full overflow-y-auto pb-5">
          {children}
        </ScrollArea>
      </SheetContent>
    </Sheet>
  );
}
